<!-- 新建/编辑房屋信息管理 -->
<template>
  <el-main style="background: #ffffff;">
    <div class="tableList" :style="{padding:0,margin: 0}">
      <div class="tableContent" :style="{padding:'10px 15px'}">
        <div class="cropper-app">
          <el-form v-if="typeMess == 1" :model="formValidateHouseInfo" :rules="ruleHouseInfoValidate" ref="formValidate"  label-width="120px">
            <el-form-item label="房屋信息名称" prop="customId">
              <el-select v-model="formValidateHouseInfo.customId" placeholder="请选择房屋信息名称" size="small" style="width: 100%;">
                <el-option v-for="item in houseInfoList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="值" prop="title">
              <el-input type="textarea" v-model="formValidateHouseInfo.content"></el-input>
            </el-form-item>
          </el-form>
          <el-form v-if="typeMess == 2" :model="formValidateCost" :rules="ruleCostValidate" ref="formValidate" label-width="120px">
              <el-form-item label="名称" prop="costId">
                <el-select v-model="formValidateCost.costId" placeholder="请选择费用明细名称" size="small" style="width: 100%;">
                  <el-option v-for="item in costList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="价格" prop="price">
                <el-input type="number" v-model="formValidateCost.price"></el-input>
              </el-form-item>
              <el-form-item label="简介" prop="content">
                <el-input type="textarea" v-model="formValidateCost.introduction"></el-input>
              </el-form-item>
          </el-form>
          <el-form v-if="typeMess == 3" :model="formValidatePrice" :rules="rulePriceValidate" ref="formValidate" label-width="120px">
            <el-form-item label="租期:" prop="info">
              <el-input size="small" v-model="formValidatePrice.term"  placeholder="请输入租期"></el-input>
            </el-form-item>
            <el-form-item label="起租日期:" prop="start">
              <el-date-picker v-model="formValidatePrice.start" type="date" placeholder="请选择起租日期" style="width:100%;"></el-date-picker>
            </el-form-item>
            <el-form-item label="止租日期:" prop="finis">
              <el-date-picker v-model="formValidatePrice.finis" type="date" placeholder="请选择止租日期" style="width:100%;"></el-date-picker>
            </el-form-item>
            <el-form-item label="价格:" prop="price">
              <el-input size="small" type="number" v-model="formValidatePrice.price" placeholder="请输入价格" ></el-input>
            </el-form-item>
          </el-form>
         <!-- <el-table v-if="typeMess == 3"
            class="table"
            ref="tableData"
            :data="tableDataChild.filter((v) => v.showEdit)"
            border
            :span-method="arraySpanMethod"
            element-loading-text="拼命加载中,请等待"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.1)">
            >
            <el-table-column prop="no" label="房源编号" align="center"></el-table-column>
            <el-table-column prop="title" label="标题" align="center"></el-table-column>
            <el-table-column prop="term" label="租期" align="center">
              <template slot-scope="scope">
                <el-input size="small" v-model="scope.row.term" v-show="scope.row.showEdit" placeholder="请输入内容"></el-input>
                <span v-show="!scope.row.showEdit">{{scope.row.term}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="start" label="起租日期" align="center">
              <template slot-scope="scope">
                <el-date-picker v-model="scope.row.start" v-show="scope.row.showEdit"  type="date" placeholder="请选择起租日期"></el-date-picker>
                <span v-show="!scope.row.showEdit">{{scope.row.start}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="finis" label="止租日期" align="center">
              <template slot-scope="scope">
                <el-date-picker v-model="scope.row.finis" v-show="scope.row.showEdit"  type="date" placeholder="请选择止租日期"></el-date-picker>
                <span v-show="!scope.row.showEdit">{{scope.row.finis}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="price" label="价格" align="center">
              <template slot-scope="scope">
                <el-input size="small" v-model="scope.row.price" v-show="scope.row.showEdit" placeholder="请输入内容" ></el-input>
                <span v-show="!scope.row.showEdit">{{scope.row.price}}</span>
              </template>
            </el-table-column>
          </el-table>-->
          <el-form v-if="typeMess == 4" :model="formValidateMattress" :rules="ruleMattressValidate" ref="formValidate" label-width="120px">
            <el-form-item label="床垫:" prop="info" >
              <el-select v-model="formValidateMattress.info" placeholder="请选择床垫" :style="{width:'100%'}" size="small">
                <el-option v-for="item in parkingList" :key="item.id" :label="item.name" :value="item.name"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </el-main>
</template>

<script>
  export default {
    name: 'HousingMessageOperation',
    props: ['typeMess','addOrEdit','houseIdAOE','childData','allList','tableDataChild'],
    data () {
      return {
        formValidateHouseInfo: { // 房屋信息
          id:"",// 房屋信息id
          customId: "", // 房屋信息名称
          content: "", // 房屋信息详情
        },
        ruleHouseInfoValidate:{
          customId:[
            { required: true, message: '请选择房屋信息名称', trigger: 'change' },
          ]
        },
        houseInfoList:[], // 房屋信息列表
        formValidateCost: { // 费用明细
          id:"",// 费用明细id
          costId:"", // 费用明细名称
          price:"", // 价格
          introduction: "", // 费用详情
        },
        ruleCostValidate:{
          costId:[
            { required: true, message: '请选择费用明细', trigger: 'change' },
          ]
        },
        costList:[],//费用列表
        formValidatePrice:{// 价格信息
          id:"",// 价格id
          term:"", // 租期
          start:"", // 起租日期
          finis:"", // 止租日期
          price:"", // 价格
        },
        rulePriceValidate:{},
        formValidateMattress: { // 床垫信息
          id:"",// 床垫id
          info:"",// 床垫
        },
        ruleMattressValidate:{
          info:[
            { required: true, message: '请选择床垫', trigger: 'change' },
          ]
        },
        parkingList:[{id:1,name:"Single(92*188)"},{id:2,name:"Long Single(92*203)"},{id:3,name:"King Single(107*203)"},{id:4,name:"Double(137*188)"},{id:5,name:"Queen(153*203)"},{id:6,name:"King(183*203)"},{id:7,name:"Super King(203*203)"}], // 床垫
      }
    },
    methods: {
      // 获取房屋信息数据
      getHouseInfoList(){
        return new Promise((resolve, reject) => {
          let parameter = [{"field":"status", "fun":"ne", "value": "0"}];
          this.$api.findCustom({page:1, size:this.$store.state.size, parameter: JSON.stringify(parameter)}).then(res => {
            if (res.data.status == 200) {
              resolve(res.data.data.records);
            } else {
              resolve(res);
            }
          }).catch(err => {
            reject(err)
          })
        })
      },
      // 获取费用明细数据
      getCostList(){
        return new Promise((resolve, reject) => {
          let parameter = [{"field":"status", "fun":"ne", "value": "0"}];
          this.$api.findCost({page:1, size:this.$store.state.size, parameter: JSON.stringify(parameter)}).then(res => {
            if (res.data.status == 200) {
              resolve(res.data.data.records);
            } else {
              resolve(res);
            }
          }).catch(err => {
            reject(err)
          })
        })
      },
      // 合并单元格 - 默认接受四个值 { 当前行的值, 当前列的值, 行的下标, 列的下标 }
      arraySpanMethod({row,column,rowIndex,columnIndex }){
        if (columnIndex != 5 && columnIndex != 6 && columnIndex != 7 && columnIndex != 8){
          if (row.priceLists != undefined) {
            if (row.priceLists.length > 0){
              return [row.priceLists.length,1];
            }
          } else {
            return [0,0];
          }
        }
      },
      // 获取户型价格数据
      getPriceList(houseId){
        return new Promise((resolve, reject) => {
          let parameter = [{"field":"status", "fun":"ne", "value": "0"},{"field":"house_id","fun":"like","value": houseId}];
          this.$api.findPrice({page:1, size:this.$store.state.size, parameter: JSON.stringify(parameter)}).then(res => {
            if (res.data.status == 200) {
              resolve(res.data.data.records);
            } else {
              resolve(res);
            }
          }).catch(err => {
            reject(err)
          })
        })
      },
      // 提交上传
       async onConfirm() {
          if (this.typeMess == 1){
            this.$refs['formValidate'].validate(async(valid) => {
              if (valid) {
               let params = {},title="新增";
                if (this.addOrEdit == 1){
                  params = {
                    customId:this.formValidateHouseInfo.customId,
                    content:this.formValidateHouseInfo.content,
                    houseId:this.houseIdAOE,
                    status:1
                  }
                  title="新增";
                }
                this.$api.saveOrUpdateCustomHouse({parameter: JSON.stringify(params)}).then(res => {
                  if (res.data.status == 200) {
                    this.$message({
                      type: 'success',
                      message: title+'成功！'
                    });
                    // 保存床垫
                    this.$emit('closeHousingDialog');
                  } else {
                    this.$message({
                      type: 'error',
                      message: res.data.message
                    });
                  }
                });
              }
            })
         } else if (this.typeMess == 2){
          this.$refs['formValidate'].validate(async(valid) => {
            if (valid) {
              let params = {}, title = "新增";
              if (this.addOrEdit == 1) {
                params = {
                  costId: this.formValidateCost.costId,
                  introduction: this.formValidateCost.introduction,
                  price: this.formValidateCost.price,
                  houseId: this.houseIdAOE,
                  status: 1
                }
                title = "新增";
                this.$api.saveOrUpdateCostHouse({parameter: JSON.stringify(params)}).then(res => {
                  if (res.data.status == 200) {
                    this.$message({
                      type: 'success',
                      message: title + '成功！'
                    });
                    // 保存床垫
                    this.$emit('closeHousingDialog');
                  } else {
                    this.$message({
                      type: 'error',
                      message: res.data.message
                    });
                  }
                });
              } else {
                params = {
                  id: this.formValidateCost.costId,
                  introduction: this.formValidateCost.introduction,
                  status: 1
                }
                title = "编辑";
                this.$api.saveOrUpdateCost({parameter: JSON.stringify(params)}).then(res => {
                  if (res.data.status == 200) {
                    this.$message({
                      type: 'success',
                      message: title + '成功！'
                    });
                    // 保存床垫
                    this.$emit('closeHousingDialog');
                  } else {
                    this.$message({
                      type: 'error',
                      message: res.data.message
                    });
                  }
                });
              }
            }
          });
         } else if (this.typeMess == 3){
            /*let array  = [];
            for (let i = 0; i < this.tableDataChild.length; i++){
              let obj = {
                id:this.tableDataChild[i].priceId,
                price:this.tableDataChild[i].price,
                houseId:this.tableDataChild[i].houseId,
                start:this.tableDataChild[i].start,
                term:this.tableDataChild[i].term,
                status:1,
              };
              array.push(obj);
            }*/
            let statusList = [];
            for (let i = 0; i < this.allList.length; i++){
              let array = await this.getPriceList(this.allList[i]);
              statusList = statusList.concat(array);
            }
            for (let i = 0; i < statusList.length; i++){
              statusList[i].status = 0;
            }
            for (let i = 0; i < this.allList.length; i++){
              let obj = {
                houseId:this.allList[i],
                price:this.formValidatePrice.price,
                start:this.formValidatePrice.start == null ||  this.formValidatePrice.start == ''? "":this.getTime(this.formValidatePrice.start),
                finis:this.formValidatePrice.finis == null ||  this.formValidatePrice.finis == ''? "":this.getTime(this.formValidatePrice.finis),
                term:this.formValidatePrice.term,
                status:1,
              };
              statusList.push(obj);
            }
            this.$api.saveOrUpdatePriceBatch({parameter: JSON.stringify(statusList)}).then(res => {
              if (res.data.status == 200) {
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                });
                this.$emit('closeHousingDialog');
              } else {
                this.$message({
                  type: 'error',
                  message: res.data.message
                });
              }
            });
          } else if (this.typeMess == 4){
            this.$refs['formValidate'].validate(async(valid) => {
              if (valid) {
                let params = {},title="新增";
                if (this.addOrEdit == 1){
                  params = {
                    info:this.formValidateMattress.info,
                    houseId:this.houseIdAOE,
                    status:1
                  }
                  title="新增";
                }
                this.$api.saveOrUpdateMattress({ parameter: JSON.stringify(params)}).then(res => {
                  if (res.data.status == 200) {
                    this.$message({
                      type: 'success',
                      message: title + '成功！'
                    });
                    // 保存床垫
                    this.$emit('closeHousingDialog');
                  } else {
                    this.$message({
                      type: 'error',
                      message: res.data.message
                    });
                  }
                })
              }
            })
          }
      },
      // 获取时间
      getTime(time) {
        if (time == undefined || time == null || time == "") {
          return null;
        } else {
          const d = new Date(time);
          const resDate = d.getFullYear() + '-' + this.p((d.getMonth() + 1)) + '-' + this.p(d.getDate());
          return resDate;
        }
      },
      // 时间是否需要补0
      p(s) {
        return s < 10 ? '0' + s : s
      },
      // 重新赋值
      clearContent(){
        if (this.typeMess == 1){
          this.formValidateHouseInfo =  { // 房屋信息
            id:"",// 房屋信息id
            name: "", // 房屋信息名称
            content: "", // 房屋信息详情
          }
        } else if(this.typeMess == 2){
          this.formValidateCost = { // 费用明细
            id:"",// 费用明细id
            costId: "", // 费用明细名称
            price: "", // 费用明细名称
            introduction: "", // 费用详情
          }
        } else if(this.typeMess == 3){
          this.formValidatePrice = {// 价格信息
            id:"",// 费用明细id
            term:"", // 租期
            start:"", // 起租日期
            finis:"", // 止租日期
            price:"", // 价格
          }
        } else if(this.typeMess == 4){
          this.formValidateMattress = { // 床垫信息
            id:"",// 床垫
            info:"",// 床垫
          }
        }
      },
      //返回上一页
      onCancel(){
        this.$emit('closeHousingDialog');
      },
      //获取房屋信息数据
      getHouseInfoNew(houseId){
        let parameter = [{
          "field":"status",
          "fun":"ne",
          "value": "0"
        },{
          "field":"house_id",
          "fun":"eq",
          "value": houseId
        }];
        this.$api.findCustomHouse({page:1, size:this.$store.state.size, parameter: JSON.stringify(parameter)}).then(async res => {
          if (res.data.status == 200) {
            this.table.houseTableData = res.data.data.records;
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
    },
   async mounted(){
     try {
       if (this.typeMess == 1){
         // 获取房屋信息数据
         this.houseInfoList = await this.getHouseInfoList();
       } else if (this.typeMess == 2){
         // 获取费用明细数据
         this.costList = await this.getCostList();
       }
     } catch (err) {
       console.log(err)
     }
     if (this.typeMess == 2){
       if (this.addOrEdit == 2){
         this.formValidateCost.id = this.childData.id;
         this.formValidateCost.costId = this.childData.costId;
         this.formValidateCost.price = this.childData.price;
         this.formValidateCost.introduction = this.childData.introduction;
       }
     }
     /*else if(this.typeMess == 3){
       for (let i = 0; i < this.tableDataChild.length; i++){
         for (let j = 0; j < this.allList.length; j++){
           if (this.tableDataChild[i].id == this.allList[j] || this.tableDataChild[i].houseId == this.allList[j]){
             this.$set(this.tableDataChild[i],"showEdit",true);
           }
         }
       }
     }*/
    }
  }
</script>

<style scoped>
  @import "../../assets/css/detaileds.css";/* 列表样式 */
</style>





// WEBPACK FOOTER //
// src/components/Menu/HousingMessageOperation.vue